import React from 'react';
import Store from '../../../store/Store';

export type FleetSection = 'drones' | 'stations' | 'areas';

interface FleetTab {
	section: FleetSection;
	label: string;
	path: string;
}

interface FleetTabsProps {
	section: FleetSection;
}

const fleetTabs: FleetTab[] = [
	{ section: 'drones', label: 'Drohnen', path: '/flottenmanagement' },
	{ section: 'stations', label: 'Drohnenstationen', path: '/drohnenstationen' },
	{ section: 'areas', label: 'Flächen', path: '/flaechen' },
];

export const FleetTabs: React.FC<FleetTabsProps> = ({ section }) => {
	return (
		<div className="inline-flex rounded-full border border-[#0063A3] bg-white p-1">
			{fleetTabs.map((tab) => {
				const isActive = tab.section === section;

				return (
					<button
						key={tab.section}
						type="button"
						className={
							'min-w-[120px] rounded-full px-6 py-3 text-sm font-semibold transition ' +
							(isActive
								? 'bg-[#0063A3] text-white'
								: 'bg-white text-[#0063A3] hover:bg-[#EDF4FA]')
						}
						onClick={() => Store.navigate(tab.path)}
					>
						{tab.label}
					</button>
				);
			})}
		</div>
	);
};
